import React from "react";

import { Button } from "@mapmycustomers/ui";

import messages from "@app/scene/routes/component/RouteDetails/components/View/components/MoveStopsWizard/messages";

import formatMessage from "./formatMessage";
import styles from "./getMoveStopsNotificationNode.module.scss";

const getMoveStopsNotificationNode = (
  message: string,
  onViewClick: () => void,
  secondaryMessages?: string[]
) => (
  <div className={styles.container}>
    <span>{message}</span>
    {secondaryMessages?.map((secondaryMessage, index) => (
      <span className={styles.secondary} key={index}>
        {secondaryMessage}
      </span>
    ))}
    <Button onClick={onViewClick}>{formatMessage(messages.view)}</Button>
  </div>
);

export default getMoveStopsNotificationNode;
